/**
 *
 * Returns true if the timestamp is within the day range
 */
export const isWithinDayRange = (timestamp: number, dayRange: number) => {
    if (isNaN(timestamp) || isNaN(dayRange)) return false
    const now = new Date().getTime() / 1000
    if(!timestamp || timestamp === 0) timestamp = now
    dayRange = dayRange * 86400 // Convert days to seconds
    const diff = Math.abs(now - timestamp)
    return diff <= dayRange && diff >= 0
  }